export const CONFIG_JSON_GET = 'CONFIG_JSON_GET'
export const CONFIG_JSON_UPDATE = 'CONFIG_JSON_UPDATE'
export const CONFIG_JSON_ERROR = 'CONFIG_JSON_ERROR'

export const META_GET = 'META_GET'
export const META_UPDATE = 'META_UPDATE'
export const META_ERROR = 'META_ERROR'

export const NAVIGATION_FORWARD = 'NAVIGATION_FORWARD'
export const NAVIGATION_SET = 'NAVIGATION_SET'

export const HEADER_SHOW = 'HEADER_SHOW'
export const HEADER_UPDATE = 'HEADER_UPDATE'
export const HEADER_CLEAR = 'HEADER_CLEAR'

export const SKIP_SHOW = 'SKIP_SHOW'
export const SKIP_CLEAR = 'SKIP_CLEAR'

export const USER_DATA_UPDATE = 'USER_DATA_UPDATE'

export function getConfigJson(payload = {}) {
  return {
    type: CONFIG_JSON_GET,
    payload,
  }
}

export function updateConfigJson(payload = {}) {
  return {
    type: CONFIG_JSON_UPDATE,
    payload,
  }
}

export function errorConfigJson(payload = {}) {
  return {
    type: CONFIG_JSON_ERROR,
    payload,
  }
}

export function getMeta(payload = {}) {
  return {
    type: META_GET,
    payload,
  }
}

export function updateMeta(payload = {}) {
  return {
    type: META_UPDATE,
    payload,
  }
}

export function errorMeta(payload = {}) {
  return {
    type: META_ERROR,
    payload,
  }
}

export function forwardNavigation(payload = {}) {
  return {
    type: NAVIGATION_FORWARD,
    payload,
  }
}

export function setNavigation(payload = {}) {
  return {
    type: NAVIGATION_SET,
    payload,
  }
}

export function showHeader(payload = {}) {
  return {
    type: HEADER_SHOW,
    payload,
  }
}

export function updateHeader(payload = {}) {
  return {
    type: HEADER_UPDATE,
    payload,
  }
}

export function clearHeader(payload = {}) {
  return {
    type: HEADER_CLEAR,
    payload,
  }
}

export function showSkip(payload = {}) {
  return {
    type: SKIP_SHOW,
    payload,
  }
}

export function clearSkip(payload = {}) {
  return {
    type: SKIP_CLEAR,
    payload,
  }
}

export function updateUserData(payload = {}) {
  return {
    type: USER_DATA_UPDATE,
    payload,
  }
}
